const myFont = "'Noto Sans JP', sans-serif";
export const fonts = {
    heading: myFont,
    body: myFont,
    fonts: myFont  
};